import alerts from "constants/alerts";

// Field configuration for HelpCenter screen
export const FIELD_CONFIG = {
  feedbackType: { 
    key: 'feedbackType', 
    message: alerts?.select_feedback_type 
  },
  subFeedbackType: { 
    key: 'subFeedbackType', 
    message: alerts?.select_sub_feedback_type 
  },
  feedbackValue: { 
    key: 'feedbackValue', 
    message: alerts?.enter_feedback_value 
  }
};

// Generate validation fields object from config
export const VALIDATION_FIELDS = Object.keys(FIELD_CONFIG).reduce((acc, key) => {
  acc[key] = false;
  return acc;
}, {});
